import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sinv-range',
  templateUrl: './sinv-range.component.html',
  styleUrls: [],
  standalone: false
})
export class SINVRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
